import React from "react";
import { FaUsers, FaLeaf, FaGlobe, FaRunning } from "react-icons/fa";

const Philosophy = () => {
  const principles = [
    {
      title: "Stakeholder Engagement",
      icon: FaUsers,
      description:
        "Building trust and collaboration across every project, ensuring meaningful connections.",
    },
    {
      title: "ESG Integration",
      icon: FaLeaf,
      description:
        "Embedding environmental, social, and governance principles into business strategy.",
    },
    {
      title: "Sustainable Development",
      icon: FaGlobe,
      description:
        "Driving initiatives that balance growth, purpose, and long-term positive impact.",
    },
    {
      title: "Endurance & Resilience",
      icon: FaRunning,
      description:
        "Applying lessons from running and cycling; patience, strategy, and grit, to professional life.",
    },
  ];

  return (
    <section className="relative py-24 px-6 md:px-20 bg-black text-white overflow-hidden">
      {/* Subtle background accents */}
      <div className="absolute -top-32 -left-32 w-64 h-64 bg-white opacity-5 rounded-full blur-3xl pointer-events-none"></div>
      <div className="absolute -bottom-32 -right-32 w-72 h-72 bg-white opacity-5 rounded-full blur-3xl pointer-events-none"></div>

      {/* Heading */}
      <div className="text-center max-w-3xl mx-auto relative z-10">
        <h2 className="text-3xl md:text-4xl font-bold mb-6 animate-fadeIn">
          Philosophy & Impact
        </h2>
        <p className="md:text-lg mb-12 animate-fadeIn delay-200">
          Great leadership is about connecting <strong>purpose with performance</strong>. Across
          my career and personal life, I prioritize trust, collaboration, and sustainable impact;
          ensuring every step, every ride, and every decision leaves a positive mark.
        </p>
      </div>

      {/* Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 relative z-10">
        {principles.map((item) => {
          const Icon = item.icon;

          return (
            <div
              key={item.title}
              className="group bg-black border border-white rounded-xl p-6 text-center shadow-md transform transition-all duration-300 hover:scale-105 hover:bg-white hover:text-black cursor-pointer"
            >
              {/* Icon */}
              <div className="flex justify-center mb-4 text-white group-hover:text-black transition duration-300">
                <Icon size={32} className="text-current" />
              </div>

              {/* Title */}
              <h3 className="font-bold text-xl mb-2">{item.title}</h3>

              {/* Description */}
              <p className="text-sm">{item.description}</p>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default Philosophy;